import type { PropsWithChildren } from 'react'
import { Pressable, type View } from 'react-native'
import Animated from 'react-native-reanimated'
import { Heading3 } from '~/components/typography/Titles.tsx'
import { cn } from '~/lib/utils.ts'

const AnimatedPressable = Animated.createAnimatedComponent(Pressable)

export function ToggleButton({
  value,
  onValueChange,
  children,
  className,
  textClassName,
  disabled,
  displayOnly,
  testID,
  ref,
}: PropsWithChildren<{
  value: boolean
  onValueChange: (value: boolean) => void
  className?: string
  textClassName?: string
  disabled?: boolean
  displayOnly?: boolean
  testID?: string
  ref?: React.Ref<View>
}>) {
  return (
    <AnimatedPressable
      ref={ref}
      testID={testID}
      onPress={() => !disabled && onValueChange(!value)}
      aria-selected={value}
      className={cn(
        'group/button select-none rounded-xl border-2 p-4 transition-all duration-150',
        value ? 'border-muted bg-muted' : 'border-muted bg-card',
        !disabled && !displayOnly && 'hover:scale-[1.02] active:scale-[0.98]',
        className,
        disabled && 'opacity-50'
      )}>
      {typeof children === 'string' ? (
        <Heading3 className={cn('text-center', textClassName)}>{children}</Heading3>
      ) : (
        children
      )}
    </AnimatedPressable>
  )
}
